<template>
   <div class="schema">
      <Modal :show="show_edit_modal" content_class="col-12 col-md-7 col-lg-6 col-xl-5" @close="$store.commit('show_edit_modal',false)">
         <template slot="title">
            <div class="title">{{SchemaModel.forms.edit_schema.title}}</div>
            <div class="subtitle">{{SchemaModel.forms.edit_schema.subtitle}}</div>
         </template>
         <template slot="content">
            <div>
               <Form 
                  class_binding="row" 
                  :ref="SchemaModel.forms.edit_schema.name" 
                  :forms="SchemaModel.forms.edit_schema.forms" 
                  :form_data="SchemaModel.forms.edit_schema.data"
               />
               <div class="btns clearfix">
                  <div class="btn btn-primary btn-r" @click="updateSchema({ref: $refs[SchemaModel.forms.edit_schema.name]})" :disabled="loading">
                     Save <div class="lds-ring" v-show="loading"><div></div><div></div><div></div><div></div></div>
                  </div>
               </div>
            </div>
         </template>
      </Modal>

      <Table v-bind="SchemaModel.tables.schema.props" :data="schemata" @on-action="handleActions">
         <template slot-scope="{ row }" slot="date">
            <strong class="tx-small">{{ moment(row.created_at).format('DD-MM-YYYY') }}</strong>
         </template>
         <template slot-scope="{ row }" slot="time">
            <strong class="tx-small">{{ moment(row.created_at).format('HH:mm') }}</strong>
         </template>
      </Table>
   </div>
</template>

<script>
import schema from "./schema.store";

export default {
   beforeDestroy () {
      this.$store.unregisterModule('schema')
   },
   created(){
      Event.$emit('loader:show',true)
      utils.registerModule('schema',schema,this.$store)
   },
   components:{
      Delete: () => import("wino-template/components/delete"),
      Modal: () => import("wino-template/components/modal"),
      Form: () => import("clarks/components/form"),
      Table: () => import("clarks/components/ivu-table"),
   },
   data (){
      return {
         moment,
      };
   },
   computed: {
      ...mapGetters([
         'SchemaModel',
         'schemata',
         'loading',
         'delete_message',
         'show_edit_modal',
      ])
   },
   methods: {
      ...mapActions([
         'updateSchema',
         'fetchData',
         'handleActions',
      ]),
   },
   async mounted(){
      utils.registerModule('schema',schema,this.$store)
      await this.fetchData()
   }
}
</script>

<style lang="scss">
   .schema{
      .tx-small{
         font-size: 12px;
      }
   }
</style>